const commonScripts = () => {
	const menu = document.getElementById('menu');
	const toggle = document.getElementById('menuToggle');

	// IE detect
	(document.documentMode) ? document.body.classList.add('browser--ie') : false;

	// toggle burger menu
	toggle.addEventListener('click', (e) => {
		e.preventDefault();

		menu.classList.toggle('header__menu--active');
		toggle.classList.toggle('header__toggle--active');
		document.body.classList.toggle('page--locked');

		if (toggle.classList.contains('header__toggle--active')) {
			toggle.textContent = "Zamknij";
		} else {
			toggle.textContent = "Menu";
		}
	});

	// toggle menu dropdowns
	const dropdowns = document.querySelectorAll('.header__dropdown');

	if (dropdowns && window.innerWidth < 768) {
		for (const dropdown of dropdowns) {
			dropdown.onclick = e => {
				if (e.target == dropdown) {
					dropdown.classList.toggle('header__dropdown--active');
				}
			};
		}
	}

	// toggle search
	const search = document.querySelector('.header__search');
	const search_input = document.querySelector('.header__search-input');
	const search_open = document.querySelector('.header__search-submit');
	const search_close = document.querySelector('.header__search-close');

	search_input.onkeydown = e => {
		if (e.key == 'Enter' && e.target.value) {
			window.location.href = `${window.location.origin}/szukaj/${search_input.value}`;
		}
	};

	search_open.onclick = e => {
		e.preventDefault();

		if (document.body.classList.contains('search_open')) {
			if (search_input.value) {
				window.location.href = `${window.location.origin}/szukaj/${search_input.value}`;
			}
		} else {
			document.body.classList.add('search_open')
			search_input.focus();
		}
	};

	search_close.onclick = e => {
		e.preventDefault();
		document.body.classList.remove('search_open')
	};

	// clone footer nav to burger menu
	const footer_nav = document.querySelector('.footer__nav-right').cloneNode(true);
	const footer_links = footer_nav.querySelectorAll('a');

	if (footer_links && !document.documentMode) {
		const header_tools = document.querySelector('.header__tools');
		const footer_links_copy = footer_links;

		let new_links = '';

		for (const link of footer_links_copy) {
			link.classList.add('header__tools-link', 'header__tools-link--footer');

			new_links += link.outerHTML;
		}

		header_tools.insertAdjacentHTML('afterbegin', new_links);
	}

	// info bar
	const infoBar = document.getElementById('infoBar');

	if (infoBar) {
		const infoBarClose = document.getElementById('infoBarClose');

		if (localStorage.getItem('infoBar')) {
			infoBar.remove();
			document.querySelector('html').classList.remove('has-info-bar');
		} else {
			document.querySelector('html').classList.add('has-info-bar');
		}

		infoBarClose.onclick = e => {
			e.preventDefault();

			document.querySelector('html').classList.remove('has-info-bar');
			localStorage.setItem('infoBar', false);
		};
	}
};

export default commonScripts;



// WEBPACK FOOTER //
// ./assets/js/common.js